
const Projeler = resolve => {
    require.ensure(['../views/apps/projeler/Projeler'], () => {
        resolve(require('../views/apps/projeler/Projeler'))
    })
};

const ProjeTanimla = resolve => {
    require.ensure(['../views/apps/projeler/ProjeTanimla'], () => {
        resolve(require('../views/apps/projeler/ProjeTanimla'))
    })
};
const ProjelerListe = resolve => {
    require.ensure(['../views/apps/projeler/ProjelerListe'], () => {
        resolve(require('../views/apps/projeler/ProjelerListe'))
    })
};

const ProjelerDuzenle = resolve => {
    require.ensure(['../views/apps/projeler/ProjelerDuzenle'], () => {
        resolve(require('../views/apps/projeler/ProjelerDuzenle'))
    })
};
const Kategori = resolve => {
    require.ensure(['../views/apps/projeler/kategori/Kategori'], () => {
        resolve(require('../views/apps/projeler/kategori/Kategori'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/projeler/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/projeler/kategori/KategoriTanimlama'))
    })
};
const KategoriListesi = resolve => {
    require.ensure(['../views/apps/projeler/kategori/KategoriListesi'], () => {
        resolve(require('../views/apps/projeler/kategori/KategoriListesi'))
    })
};
const KategoriDuzenle = resolve => {
    require.ensure(['../views/apps/projeler/kategori/KategoriDuzenle'], () => {
        resolve(require('../views/apps/projeler/kategori/KategoriDuzenle'))
    })
};
import Vue from 'vue'
Vue.component('ProjeTanimla', ProjeTanimla);
Vue.component('ProjeListesi', ProjelerListe);
Vue.component('ProjeDuzenle', ProjelerDuzenle);
Vue.component('ProjeKategoriTanimla', KategoriTanimlama);
Vue.component('ProjeKategoriListe', KategoriListesi);
Vue.component('ProjeKategoriDuzenle', KategoriDuzenle);
import layouts from '../layout'

export default {
    path: '/projeler',
    name: 'projeler',
    component: Projeler,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'projelertanimla',
            component: ProjeTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'liste',
            name: 'projelerliste',
            component: ProjelerListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'guncelleme',
            name: 'projelerduzenle',
            component: ProjelerDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'kategori',
            name: 'kategori',
            component: Kategori,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            },
            children: [
                {
                    path: 'islem',
                    name: 'kategoriislem',
                    component: KategoriTanimlama,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                }
            ]
        },
    ]
}
